(() => {
  if (window.__mediaGoNlTrackingLoaded) return;
  window.__mediaGoNlTrackingLoaded = true;

  const configElement = document.getElementById('MediaGoTrackingConfig');
  if (!configElement) return;

  let config;
  try {
    config = JSON.parse(configElement.textContent);
  } catch (error) {
    console.error('MediaGo tracking configuration is invalid.', error);
    return;
  }

  const trackingToken = 'f9f2b1ef23fe2759c2cad0953029a94b';

  const createEventId = () => {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  };

  const pushEvent = (name, data = {}) => {
    const eventConfig = config.events[name];
    if (!eventConfig) return;

    const eventId = createEventId();
    window._megoaa = window._megoaa || [];
    window._megoaa.push({
      type: 'event',
      name,
      acid: eventConfig.acid,
      pxd: eventConfig.pxd,
      event_id: eventId,
      ...data,
    });

    const query = new URLSearchParams({
      cvn: name,
      acid: eventConfig.acid,
      pxd: eventConfig.pxd,
      tn: trackingToken,
      event_id: eventId,
    });

    Object.entries(data).forEach(([key, value]) => {
      if (value === undefined || value === null || value === '') return;
      query.set(key, typeof value === 'object' ? JSON.stringify(value) : String(value));
    });

    const pixel = new Image(1, 1);
    pixel.style.display = 'none';
    pixel.src = `https://trace.mediago.io/api/bidder/track/pixel/conversion?${query.toString()}`;
  };

  const pageData = {
    page_url: config.page.url,
    page_title: config.page.title,
    page_type: config.page.type,
    currency: config.currency,
  };

  if (config.page.product) {
    pageData.content_type = 'product';
    pageData.content_ids = [String(config.page.product.id)];
    pageData.variant_id = String(config.page.product.variantId);
    pageData.content_name = config.page.product.title;
    pageData.value = config.page.product.price;
  }

  pushEvent('view', pageData);

  const isCartAddRequest = (input, init) => {
    const rawUrl = typeof input === 'string' ? input : input && input.url;
    if (!rawUrl) return false;

    const method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    if (method !== 'POST') return false;

    try {
      const pathname = new URL(rawUrl, window.location.origin).pathname.replace(/\/$/, '');
      return pathname.endsWith('/cart/add') || pathname.endsWith('/cart/add.js');
    } catch (_error) {
      return false;
    }
  };

  const normalizeCartItems = (responseData) => {
    if (!responseData || typeof responseData !== 'object') return [];
    const rawItems = Array.isArray(responseData.items) ? responseData.items : [responseData];

    return rawItems
      .filter((item) => item && (item.id || item.variant_id))
      .map((item) => ({
        content_id: String(item.product_id || item.id || item.variant_id),
        variant_id: String(item.variant_id || item.id),
        content_name: item.product_title || item.title || '',
        quantity: Number(item.quantity || 1),
        price: Number(item.final_price ?? item.price ?? 0) / 100,
      }));
  };

  const trackAddedItems = (items) => {
    const contents = items.filter((item) => item.content_id);
    const value = contents.reduce((total, item) => total + item.price * item.quantity, 0);

    pushEvent('addtocart', {
      currency: config.currency,
      value: Number(value.toFixed(2)),
      content_ids: contents.map((item) => item.content_id),
      contents,
    });
  };

  const originalFetch = window.fetch;
  if (typeof originalFetch === 'function') {
    window.fetch = async function (...args) {
      const response = await originalFetch.apply(this, args);

      if (response.ok && isCartAddRequest(args[0], args[1])) {
        response.clone().json()
          .then((responseData) => trackAddedItems(normalizeCartItems(responseData)))
          .catch(() => trackAddedItems([]));
      }

      return response;
    };
  }

  // Covers non-AJAX product forms. AJAX forms are reported only after fetch succeeds.
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || event.defaultPrevented) return;
    if (!isCartAddRequest(form.action, { method: form.method })) return;

    const formData = new FormData(form);
    const variantId = formData.get('id');
    const quantity = Number(formData.get('quantity') || 1);

    trackAddedItems(variantId ? [{
      content_id: String(variantId),
      variant_id: String(variantId),
      content_name: '',
      quantity,
      price: 0,
    }] : []);
  });
})();
